export default __webpack_public_path__ + "static/media/432.a1082bad.gif";